module.exports = __webpack_public_path__ + "img/front.53eecd73.svg";